/**
 * PartnerFilterSection Component
 * 협력사 출금제한 검색 필터 섹션
 */
import React, { useMemo } from 'react';
import SearchableSelect, { SelectOption } from '@/shared/components/forms/SearchableSelect';
import { SUPPLIER_STATUS_OPTIONS } from '@/shared/constants/statusCodes';
import '@/shared/styles/search-form.css';

const WITHDRAWAL_STATUS_OPTIONS: SelectOption[] = [
    { value: 'N', label: '출금허용' },
    { value: 'Y', label: '출금제한' },
];

interface PartnerFilterSectionProps {
    searchPartnerId: string;
    setSearchPartnerId: (value: string) => void;
    searchPartnerIdInput: string;
    setSearchPartnerIdInput: (value: string) => void;
    searchStatus: string;
    setSearchStatus: (value: string) => void;
    searchWithdrawalStatus: string;
    setSearchWithdrawalStatus: (value: string) => void;
    partnerNames: Array<{ suppId: string; suppName: string }>;
    loading: boolean;
    onSearch: () => void;
    onReset: () => void;
}

const PartnerFilterSection: React.FC<PartnerFilterSectionProps> = ({
                                                                       searchPartnerId,
                                                                       setSearchPartnerId,
                                                                       searchPartnerIdInput,
                                                                       setSearchPartnerIdInput,
                                                                       searchStatus,
                                                                       setSearchStatus,
                                                                       searchWithdrawalStatus,
                                                                       setSearchWithdrawalStatus,
                                                                       partnerNames,
                                                                       loading,
                                                                       onSearch,
                                                                       onReset,
                                                                   }) => {
    const partnerOptions: SelectOption[] = useMemo(
        () => partnerNames.map((p) => ({ value: p.suppId, label: p.suppName })),
        [partnerNames]
    );

    const statusOptions: SelectOption[] = useMemo(
        () => SUPPLIER_STATUS_OPTIONS
            .filter((o) => o.value !== '')
            .map((o) => ({ value: o.value as string, label: o.label as string })),
        []
    );

    return (
        <div className="card search-card">
            <div className="card-body">
                <div className="search-form partner-accounting-search-form">
                    {/* 협력사명 */}
                    <div className="form-group">
                        <div className="form-field">
                            <label className="form-label">
                                <i className="fas fa-building" />
                                협력사명
                            </label>
                            <SearchableSelect
                                options={partnerOptions}
                                value={searchPartnerId}
                                onChange={setSearchPartnerId}
                                placeholder="협력사 검색..."
                                showAllOption={true}
                                allOptionLabel="전체"
                            />
                        </div>
                    </div>

                    {/* 협력사 아이디 */}
                    <div className="form-group">
                        <div className="form-field">
                            <label className="form-label">
                                <i className="fas fa-id-card" />
                                협력사 아이디
                            </label>
                            <input
                                type="text"
                                className="text-input"
                                value={searchPartnerIdInput}
                                onChange={(e) => setSearchPartnerIdInput(e.target.value)}
                                onKeyPress={(e) => e.key === 'Enter' && onSearch()}
                                placeholder="협력사 아이디 입력..."
                            />
                        </div>
                    </div>

                    {/* 운영 상태 */}
                    <div className="form-group">
                        <div className="form-field">
                            <label className="form-label">
                                <i className="fas fa-toggle-on" />
                                운영 상태
                            </label>
                            <SearchableSelect
                                options={statusOptions}
                                value={searchStatus}
                                onChange={setSearchStatus}
                                placeholder="운영 상태 선택..."
                                showAllOption={true}
                                allOptionLabel="전체"
                            />
                        </div>
                    </div>

                    {/* 출금상태 */}
                    <div className="form-group">
                        <div className="form-field">
                            <label className="form-label">
                                <i className="fas fa-money-bill-wave" />
                                출금상태
                            </label>
                            <SearchableSelect
                                options={WITHDRAWAL_STATUS_OPTIONS}
                                value={searchWithdrawalStatus}
                                onChange={setSearchWithdrawalStatus}
                                placeholder="출금상태 선택..."
                                showAllOption={true}
                                allOptionLabel="전체"
                            />
                        </div>
                    </div>

                    {/* 버튼 그룹 */}
                    <div className="form-group button-group">
                        <button
                            className="btn btn-secondary"
                            onClick={onReset}
                            disabled={loading}
                        >
                            <i className="fas fa-redo" />
                            초기화
                        </button>
                        <button
                            className="btn btn-primary"
                            onClick={onSearch}
                            disabled={loading}
                        >
                            <i className="fas fa-search" />
                            조회
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PartnerFilterSection;
